module.exports = __webpack_public_path__ + "img/6-2.ba87f146.png";